import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Dashboard screen import
import DashboardScreen from '../../screens/dashboard/DashboardScreen';

// Checklist screen imports
import { PersonalChecklistScreen } from '../../screens/checklists/PersonalChecklistScreen';
import { MedicalChecklistScreen } from '../../screens/checklists/MedicalChecklistScreen';
import { FinanceChecklistScreen } from '../../screens/checklists/FinanceChecklistScreen';
import { PropertyChecklistScreen } from '../../screens/checklists/PropertyChecklistScreen';
import FinalWishesChecklistScreen from '../../screens/checklists/FinalWishesChecklistScreen';
import { FinalCareChecklistScreen } from '../../screens/checklists/FinalCareChecklistScreen';
import { HealthcareDirectivesChecklistScreen } from '../../screens/checklists/HealthcareDirectivesChecklistScreen';
import { EstatePlanningChecklistScreen } from '../../screens/checklists/EstatePlanningChecklistScreen';
import { CarePreferencesChecklistScreen } from '../../screens/checklists/CarePreferencesChecklistScreen';
import { OnlineAccountsChecklistScreen } from '../../screens/checklists/OnlineAccountsChecklistScreen';
import { EmergencyContactsChecklistScreen } from '../../screens/checklists/EmergencyContactsChecklistScreen';
import { ExpensesChecklistScreen } from '../../screens/checklists/ExpensesChecklistScreen';
import { DocumentManagementChecklistScreen } from '../../screens/checklists/DocumentManagementChecklistScreen';
import { LoyaltyPointsChecklistScreen } from '../../screens/checklists/LoyaltyPointsChecklistScreen';
import { AllTasksChecklistScreen } from '../../screens/checklists/AllTasksChecklistScreen';

const Stack = createNativeStackNavigator();

export const DashboardNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Dashboard */}
      <Stack.Screen name="Home" component={DashboardScreen} />
      
      {/* Checklist Screens */}
      <Stack.Screen name="PersonalChecklist" component={PersonalChecklistScreen} />
      <Stack.Screen name="MedicalChecklist" component={MedicalChecklistScreen} />
      <Stack.Screen name="FinanceChecklist" component={FinanceChecklistScreen} />
      <Stack.Screen name="PropertyChecklist" component={PropertyChecklistScreen} />
      <Stack.Screen name="FinalWishesChecklist" component={FinalWishesChecklistScreen} />
      <Stack.Screen name="FinalCareChecklist" component={FinalCareChecklistScreen} />
      <Stack.Screen name="HealthcareDirectivesChecklist" component={HealthcareDirectivesChecklistScreen} />
      <Stack.Screen name="EstatePlanningChecklist" component={EstatePlanningChecklistScreen} />
      <Stack.Screen name="CarePreferencesChecklist" component={CarePreferencesChecklistScreen} />
      <Stack.Screen name="OnlineAccountsChecklist" component={OnlineAccountsChecklistScreen} />
      <Stack.Screen name="EmergencyContactsChecklist" component={EmergencyContactsChecklistScreen} />
      <Stack.Screen name="ExpensesChecklist" component={ExpensesChecklistScreen} />
      <Stack.Screen name="DocumentManagementChecklist" component={DocumentManagementChecklistScreen} />
      <Stack.Screen name="LoyaltyPointsChecklist" component={LoyaltyPointsChecklistScreen} />
      <Stack.Screen name="AllTasks" component={AllTasksChecklistScreen} />
    </Stack.Navigator>
  );
};

export default DashboardNavigator;